import { css, etiColors, mediaQueries } from '@eti/styles';
import { AncillaryRadioGroup, ValidationMessage } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { isPrimaryFlow } from '../../common/utils/primaryFlow';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const buttonsWrapperStyles = css`
  grid-column: 2;
  grid-row: 2;

  @media ${mediaQueries.small.only} {
    grid-column: 1 / 3;
    grid-row: 2;
  }
`;
const errorMessage = css`
  color: ${etiColors.critical.solid};
  font-size: 0.875rem;
  grid-column: 2;
  grid-row: 3;
  min-height: 1.125rem;

  @media ${mediaQueries.small.only} {
    grid-column: 1 / 3;
  }
`;
const selectOneStyles = css`
  grid-column: 2;
  grid-row: 1;

  @media ${mediaQueries.small.only} {
    align-content: end;
    grid-column: 1;
    grid-row: 1;
  }
`;
const AncillaryToggleBar = ({
  inputName,
  meta,
  onValueChange,
  options,
  selectedValue
}) => {
  const {
    nonDebugT,
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const shouldUseLabel = p('IbeClient.TravelerDetails.OptionalProductsRequireValidation.Enabled');
  const label = t('Product.SelectOne.Label');
  const selectOneLabel = shouldUseLabel ? nonDebugT('Input.Field.Required', label) : '';
  const isMainFlow = isPrimaryFlow();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isMainFlow && /*#__PURE__*/_jsx("div", {
      className: selectOneStyles,
      children: selectOneLabel
    }), /*#__PURE__*/_jsx("div", {
      className: buttonsWrapperStyles,
      children: /*#__PURE__*/_jsx(AncillaryRadioGroup, {
        "data-testid": "radioToggle-ancillary-radio-group",
        hasError: Boolean((meta === null || meta === void 0 ? void 0 : meta.touched) && (meta === null || meta === void 0 ? void 0 : meta.error)),
        name: inputName,
        onChange: onValueChange,
        options: options,
        selectedValue: selectedValue
      })
    }), Boolean((meta === null || meta === void 0 ? void 0 : meta.touched) && (meta === null || meta === void 0 ? void 0 : meta.error)) && /*#__PURE__*/_jsx(ValidationMessage, {
      className: errorMessage,
      "data-testid": "select-option-error-message",
      variant: "error",
      children: meta.error
    })]
  });
};
export default AncillaryToggleBar;
//# sourceMappingURL=AncillaryToggleBar.js.map